/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Type_UserInputs */

const cs_gdpr_type_user = /** @type {(inputs: Gdpr_Type_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatel`)
};

const en_gdpr_type_user = /** @type {(inputs: Gdpr_Type_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Gdpr_Type_UserInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_type_user = /** @type {((inputs?: Gdpr_Type_UserInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Type_UserInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_type_user(inputs)
	return cs_gdpr_type_user(inputs)
});